import React from 'react'
import { Group, Table } from '@mantine/core'
import { IconArrowNarrowDown, IconArrowNarrowUp } from '@tabler/icons-react'

type VersionListTableHeadProps = {
  field: string
  label: string
  sort: { field: string, dir: 'asc' | 'desc', isDate: boolean }
  onClick: (field: string) => void
}

export const VersionListTableHead = ({ field, label, sort, onClick }: VersionListTableHeadProps) => {
  return (
    <Table.Th pl={24} onClick={() => onClick(field)} style={{ cursor: 'pointer' }}>
      <Group align='center'>
        { label }
        { sort.field === field &&
        <>
          { sort.dir === 'asc' ?
            <IconArrowNarrowDown color='darkGrey' size='14'  /> :
            <IconArrowNarrowUp color='darkGrey' size='14' />
          }
        </>
        }
      </Group>
  </Table.Th>
  )
}
